import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment as env } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('web_test_application');
  protected readonly envName = signal(env.envName);
} 
